'use strict';

intellidealerAppCoreModule.factory('jsonPropertiesResource', function ($resource, appConfigurationService) {
  return {
    authDotNetProperties: $resource(appConfigurationService.basePath + '/rest/jsonValue/getFirst')
  };
});
